<template>
  <v-card class="card" :dark="complexity !== '1'" :color="cellColor">
    <v-card-text style="padding: 4px;" class="caption" v-t="{path: 'ITEM'+item+'.SHORTTITLE', locale: version}" />
    <span v-if="answered">
      <v-icon dark :color="answer">{{ icon }}</v-icon>
    </span>
    <v-icon class="pl-1" v-if="chosen" color="white" >star</v-icon>
  </v-card>
</template>

<style scoped>
.card {
  text-align: center;
}
</style>

<script>
  export default {
    name: 'evaloeResultsItem',
    props: ['complexity', 'item', 'version', 'answered', 'answer', 'chosen', 'hover'],
    data () {
      return {
      }
    },
    computed: {
      cellColor: function () {
        let col
        switch (this.complexity) {
          case '3':
            col = 'deep-purple darken-4'
            break
          case '2':
            col = 'deep-purple lighten-1'
            break
          case '1':
            col = 'deep-purple lighten-4'
            break
          default:
            col = ''
            break
        }
        return col
      },
      icon: function () {
        let faceIcon
        switch (this.answer) {
          case 'red':
            faceIcon = 'sentiment_very_dissatisfied'
            break
          case 'orange':
            faceIcon = 'sentiment_satisfied'
            break
          case 'green':
            faceIcon = 'sentiment_very_satisfied'
            break
          default:
            faceIcon = 'tick'
            break
        }
        return faceIcon
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/EvaloeResultsItem.vue